import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSiharaisakiInfoGetRes,
  TSiharaisakiListGetReq,
  TSiharaisakiRegisterPostReq,
} from "./TSiharaisaki"

/**
 * 支払先マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class SiharaisakiService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getList = async (
    params: TSiharaisakiListGetReq,
    resolve?: (param: TApiResponse<TSiharaisakiInfoGetRes[]>) => any,
    reject?: (param: TApiResponse<TSiharaisakiInfoGetRes[]> | undefined) => any
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<TSiharaisakiInfoGetRes[]>> =
        await this.getInner(`/master/siharaisaki`, params)
      return res.data
    } catch (err) {
      if (typeof err !== "object" || err == null) throw err
      const error = err as TApiResponse<TSiharaisakiInfoGetRes[]>
      throw reject ? reject(error) : error
    }
  }

  /**
   * 単体取得
   *
   * @param {TMenuInfoGetReq} params
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
   * @memberof MenuService
   */
  get = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TSiharaisakiInfoGetRes>> =
        await this.getInner(`/master/siharaisaki/${id}`, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TKyotenPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  post = async (data: TSiharaisakiRegisterPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `master/siharaisaki/`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TKyotenPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  put = async (id: string, data: TSiharaisakiRegisterPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `master/siharaisaki/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
